import { IInstallment } from './getSmartVoucher';

export type SingleVoucher = {
	commitmentDuration: number;
	deviceDiscount: number;
	upFrontPayment: number;
	installments: IInstallment[];
};

const model: types.models.InputModel = {
	commitmentDuration: 'commitmentDuration',
	deviceDiscount: 'deviceDiscount',
	upFrontPayment: 'upFrontPayment',
	installments: 'installments',
};

export default model;
